module.exports = __webpack_public_path__ + "static/media/AB_L31_2.9ec68273.jpg";